import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-topic-grid',
  templateUrl: './TopicGrid.component.html',
  styleUrls: ['./TopicGrid.component.scss']
})
export class TopicGridComponent implements OnInit {

  @Input() topicItems: any;

  constructor() {
  }

  ngOnInit() {
  }

}
